import { tv } from 'tailwind-variants';

export const searchTextFieldStyles = tv({
  base: `
    h-10
    border

    border-transparent
    bg-gray-100
    font-semibold

    reset-search

    placeholder:text-gray-500
    hover:border-gray-300

    focus:border-gray-400

    focus:bg-white
    focus:ring-gray-200
    lg:h-12
  `,
});
